export const FETCH_CONVERSATIONS_REQUEST = 'FETCH_CONVERSATIONS_REQUEST';
export const FETCH_CONVERSATIONS_SUCCESS = 'FETCH_CONVERSATIONS_SUCCESS';
export const FETCH_CONVERSATIONS_FAILURE = 'FETCH_CONVERSATIONS_FAILURE';

export const CLEAR_CONVERSATIONS = 'CLEAR_CONVERSATIONS';
export const SET_CONVERSATIONS_FILTER = 'SET_CONVERSATIONS_FILTER';
